import React from 'react';
import { ConfirmContextType } from './useDialogs';

/**
 * Create context for confirmation dialogs
 */
export const ConfirmContext = React.createContext<ConfirmContextType | null>(null);

/**
 * Hook to use confirmation dialogs
 */
export const useConfirm = () => {
  const context = React.useContext(ConfirmContext);
  if (!context) {
    throw new Error('useConfirm must be used within a ConfirmProvider');
  }
  return context;
};
